import { useState } from 'react'
import { authAPI } from '../services/api'

export default function Login({ onLogin }) {
  const [pin, setPin] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handlePinInput = (digit) => {
    if (pin.length < 6) {
      setPin(prev => prev + digit)
      setError('')
    }
  }

  const handleDelete = () => {
    setPin(prev => prev.slice(0, -1))
    setError('')
  }

  const handleSubmit = async () => {
    if (pin.length !== 6) {
      setError('PIN harus 6 digit')
      return
    }

    setLoading(true)
    try {
      const result = await authAPI.login(pin)
      if (result.success) {
        localStorage.setItem('authToken', result.token)
        onLogin()
      }
    } catch (err) {
      setError('PIN salah, coba lagi')
      setPin('')
    } finally {
      setLoading(false)
    }
  }

  const buttons = [1, 2, 3, 4, 5, 6, 7, 8, 9, null, 0, 'del']

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-600 to-blue-900 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-sm">
        {/* Logo & Title */}
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-primary rounded-2xl flex items-center justify-center mx-auto mb-4">
            <span className="text-3xl">💰</span>
          </div>
          <h1 className="text-2xl font-bold text-gray-900">Finance Tracker</h1>
          <p className="text-gray-500 text-sm mt-1">Masukkan PIN 6 digit</p>
        </div>

        {/* PIN Display */}
        <div className="flex justify-center gap-3 mb-6">
          {Array.from({ length: 6 }).map((_, i) => (
            <div
              key={i}
              className={`w-10 h-10 rounded-full border-2 flex items-center justify-center transition-all
                ${pin.length > i 
                  ? 'bg-primary border-primary' 
                  : 'border-gray-300 bg-gray-50'
                }`}
            >
              {pin.length > i && (
                <div className="w-3 h-3 bg-white rounded-full" />
              )}
            </div>
          ))}
        </div>

        {/* Error Message */}
        {error && (
          <p className="text-red-500 text-sm text-center mb-4">{error}</p>
        )}

        {/* Numpad */}
        <div className="grid grid-cols-3 gap-3 mb-4">
          {buttons.map((btn, i) => {
            if (btn === null) {
              return <div key={i} />
            }
            if (btn === 'del') {
              return (
                <button
                  key={i}
                  onClick={handleDelete}
                  className="h-14 bg-gray-100 rounded-xl flex items-center justify-center text-gray-600 hover:bg-gray-200 transition-colors font-medium"
                >
                  ⌫
                </button>
              )
            }
            return (
              <button
                key={i}
                onClick={() => handlePinInput(String(btn))}
                className="h-14 bg-gray-100 rounded-xl flex items-center justify-center text-gray-800 hover:bg-blue-50 hover:text-primary transition-colors text-xl font-semibold"
              >
                {btn}
              </button>
            )
          })}
        </div>

        {/* Submit Button */}
        <button
          onClick={handleSubmit}
          disabled={pin.length !== 6 || loading}
          className={`w-full h-12 rounded-xl font-semibold text-white transition-all
            ${pin.length === 6 && !loading
              ? 'bg-primary hover:bg-blue-700' 
              : 'bg-gray-300 cursor-not-allowed'
            }`}
        >
          {loading ? (
            <span className="flex items-center justify-center gap-2">
              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
              Memverifikasi...
            </span>
          ) : 'Masuk'}
        </button>
      </div>
    </div>
  )
}
